import React from 'react';
import { Box, Button } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

interface WizardNavigationProps {
  currentStep: number;
  onStepChange: (step: number) => void;
  onComplete: () => void;
}

const WizardNavigation: React.FC<WizardNavigationProps> = ({ 
  currentStep, 
  onStepChange,
  onComplete 
}) => {
  const totalSteps = 4;

  const handleNext = () => {
    if (currentStep < totalSteps) {
      onStepChange(currentStep + 1);
    } else {
      onComplete();
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      onStepChange(currentStep - 1);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        borderTop: '1px solid #e9ecef',
        display: 'flex',
        justifyContent: 'space-between',
        background: 'white'
      }}
    >
      <Button
        variant="outlined"
        startIcon={<ArrowBack />}
        onClick={handleBack}
        disabled={currentStep === 1}
      >
        Back
      </Button>
      <Button
        variant="contained"
        endIcon={currentStep === totalSteps ? null : <ArrowForward />}
        onClick={handleNext}
      >
        {currentStep === totalSteps ? 'Complete' : 'Next'}
      </Button>
    </Box>
  );
};

export default WizardNavigation; 